"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBANK_IDS = void 0;
const types_1 = require("./types");
exports.DEBANK_IDS = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: 'eth',
    [types_1.Networks.Polygon]: 'matic',
    [types_1.Networks.Arbitrum]: 'arb',
    [types_1.Networks.Avalanche]: 'avax',
    [types_1.Networks.Moonriver]: 'movr',
    [types_1.Networks.Fantom]: 'ftm',
    [types_1.Networks.Cronos]: 'cro',
    [types_1.Networks.Canto]: 'canto',
    [types_1.Networks.Aurora]: 'aurora',
    [types_1.Networks.Harmony]: 'hmy',
    [types_1.Networks.Moonbeam]: 'mobm',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Blast]: 'blast',
    [types_1.Networks.ZksyncEra]: 'era',
    [types_1.Networks.Base]: 'base',
    [types_1.Networks.Mantle]: 'mnt',
    [types_1.Networks.Scroll]: 'scrl',
    [types_1.Networks.Optimism]: 'op',
    [types_1.Networks.Real]: 'real',
    [types_1.Networks.Sonic]: 'sonic',
    [types_1.Networks.Linea]: 'linea',
};
